import { useBootSplashReady } from '@affine/core/bootstrap/boot-splash';
import { DesktopApiService } from '@affine/core/modules/desktop-api';
import { useServiceOptional } from '@toeverything/infra';
import { useEffect } from 'react';

export function useDesktopAppLayoutReady(ready = true) {
  const desktopApi = useServiceOptional(DesktopApiService);
  useBootSplashReady(ready);

  useEffect(() => {
    if (!ready || !BUILD_CONFIG.isElectron) {
      return;
    }

    desktopApi?.handler.ui.pingAppLayoutReady().catch(console.error);
  }, [desktopApi, ready]);
}
